import skizz from '../core/index'

import fire from './fire'
import off from './off'
import on from './on'
import one from './one'

skizz.fn.fire = fire
skizz.fn.off = off
skizz.fn.on = on
skizz.fn.one = one
